module.exports = __webpack_public_path__ + "assets/img/03.f8d556a6.png";